import React from "react";
import { store } from "../../../reducer/Store";
import { Spinner } from "react-bootstrap";
import ApiService from "../../../services/ApiService";
import TableDynamic from "../../../components/TableDynamic";
import { ToastContainer, toast } from "react-toastify";
import CustomersListModal from "../../../components/planstrade/CustomersListModal";
const CustomersList = ({
  refreshTab,
  showAdd,
  setShowAdd,
  setDetailsCustomerList,
  setShowDetailsCustomerList,
}) => {
  const { dispatch, state } = React.useContext(store);
  const allStatus = state.allStatus;
  const [showUpdate, setShowUpdate] = React.useState(false);
  const [nameCustomerList, setNameCustomerList] = React.useState("");
  const [customerListId, setCustomerListId] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const columnsName = ["Liste clients", ""];
  const columns = ["name", "updateAndDeletePlan"];
  const [noResultMessage, setNoResultMessage] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [loaderAddUpdate, setLoaderAddUpdate] = React.useState(false);
  const [dataPage, setDataPage] = React.useState([]);
  const [valueGroupement, setGroupement] = React.useState([]);
  const [valueStatus, setStatus] = React.useState(allStatus[0]);
  const [valueTags, setTags] = React.useState(
    state.currentBrands && state.currentBrands.length === 1
      ? state.currentBrands[0]
      : []
  );
  const [searchValue, setSearchValue] = React.useState("");
  const [checkedCustomersIds, setCheckedCustomersIds] = React.useState([]);
  const [isAllChecked, setIsAllChecked] = React.useState(
    state.listBrands.slice(1)
  );
  const [updateCustomerData, setUpdateCustomerData] = React.useState([]);
  const [noResultMessageInModal, setNoResultMessageInModal] =
    React.useState(false);
  const [textImportId, setTextImportId] = React.useState("");

  // <JC
  const allBrands = state.allBrands;
  const [valueBrands, setBrands] = React.useState(allBrands[0]);
  // JC>

  /**
   * Cette fonction gère la modification de la valeur de l'import d'identifiants en texte brut, en remplaçant les sauts de ligne et les espaces par des virgules.
   * @param {Object} event - L'événement associé à la modification de la valeur de l'input.
   */
  const handleImportId = (event) => {
    const value = event.target.value;
    let newValue = value
      .replace(/\n/g, ",") // Remplace les sauts de ligne par des virgules
      .replace(/ +(?= )/g, "") // Remplace les espaces multiples par une seule virgule
      .replace(/ /g, ","); // Remplace les espaces restants par des virgules
    setTextImportId(newValue);
  };

  const handleClose = () => {
    setNoResultMessageInModal(false);
    setNoResultMessage(false);
    setShowAdd(false);
    setShowUpdate(false);
    setTextImportId([]);
    setDataPage([]);
    setGroupement(state.allGroups[0]);
    setStatus(allStatus[0]);
    setTags(state.currentBrands.length === 1 ? state.currentBrands[0] : []);
    setNameCustomerList("");
    setCustomerListId("");
    setErrorMessage("");
    setUpdateCustomerData([]);
    setCheckedCustomersIds([]);
    setIsAllChecked([]);
    setSearchValue("");
    dispatch({
      type: "SET_CUSTOMERSLISTFILTER",
      payload: [],
    });

    // <JC
    setBrands(0);
    // JC>

  };

  /**
   * Cette fonction est appelée lorsque l'utilisateur souhaite modifier une liste de clients existante. Elle récupère les informations de la liste de clients sélectionnée (l'ID de la liste, le nom de la liste, les IDs des clients de la liste), puis appelle la fonction getCustomers() pour récupérer les informations sur les clients de la liste sélectionnée. Elle met ensuite à jour les états showUpdate, checkedCustomersIds, dataPage, nameCustomerList, groupement et status.
   * @param {Object} values - Les informations sur la liste de clients sélectionnée.
   * @param {Number} currentPage - Le numéro de la page courante.
   * @param {Number} max - Le nombre maximal d'éléments à afficher par page.
   * @param {String} search - Le texte à rechercher.
   */
  const handleShowUpdate = (values, currentPage, max, search) => {
    setCustomerListId(values.id);
    var customersIds = values.customer_customer_lists.map(
      (elt) => elt.customer_id
    );
    setCheckedCustomersIds(customersIds);
    getCustomers(customersIds);
    setDataPage({ currentPage: currentPage, max: max, search: search });
    setNameCustomerList(values.name);
    setGroupement(state.allGroups[0]);
    setStatus(allStatus[0]);

   

    // <JC
    setBrands(allBrands[values.brand_id-1]);
    // JC>

    setErrorMessage("");
    setShowUpdate(true);
  };

  /**
   * Cette fonction récupère une liste paginée de clients pour un plan spécifique.
   * @param {Number} page - Le numéro de la page à récupérer. Par défaut, la première page est récupérée.
   * @param {Number} max - Le nombre maximum d'éléments par page. Par défaut, 25 éléments sont récupérés.
   */

  const getPlanCustomersList = async (page = 1, max = 25) => {
   
    // <JC
    var state_brands_ids = state.currentBrands;
    var brands_ids = '';
    state_brands_ids.map((val) => (
      brands_ids += val.value+','
    ));
    // JC>

    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},

      // <JC
      `customer-lists-pagination?page=${page}&max=${max}&brands=${brands_ids}`,
      // JC>
      "get"
    )
      .then(function (response) {
        dispatch({ type: "SET_LOADER", payload: false });
        dispatch({
          type: "SET_PLANSTRADECUSTOMERSLIST",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction effectue une recherche sur les listes de clients en fonction de la chaîne de caractères de recherche fournie, puis renvoie les résultats paginés.
   * @param { String } search - La chaîne de caractères à rechercher dans les noms des listes de clients.
   * @param { Number } page - Le numéro de la page à renvoyer, par défaut 1.
   * @param { Number } max - Le nombre maximal de résultats à renvoyer par page, par défaut 25.
   */
  const searchCustomersList = (search, page = 1, max = 25) => {

    // <JC
    var state_brands_ids = state.currentBrands;
    var brands_ids = '';
    state_brands_ids.map((val) => (
      brands_ids += val.value+','
    ));
    // JC>

    dispatch({ type: "SET_LOADER", payload: true });
    setNoResultMessage(false);
    ApiService.request(
      {
        search,
        page,
        max,
        // <JC
        brands_ids
        // JC>

      },
      "customer-lists-search-paginated",
      "post"
    )
      .then(function (response) {
        if (response.message === "No result.") {
          setNoResultMessage(true);
        } else {
          dispatch({
            type: "SET_PLANSTRADECUSTOMERSLIST",
            payload: response.data,
          });
        }
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction récupère les informations des clients correspondant aux ids fournis dans le tableau customersIds et les stocke dans l'état local updateCustomerData.
   * Elle met également à jour les tableaux isAllChecked et checkedCustomersIds pour refléter les nouveaux clients récupérés.
   * @param { Array } customersIds - Le tableau des ids des clients à récupérer.
   * @returns { Array } Le tableau des clients récupérés.
   * @throws Une erreur si la requête échoue.
   */
  const getCustomers = async (customersIds) => {
    setLoader(true);
    var tabCheckedAll = [...isAllChecked];
    var tabChecked = [...checkedCustomersIds];
    try {
      const response = await ApiService.request(
        { ids: customersIds.toString() },
        "customersByIds",
        "post"
      );
      response.data.map((elt) =>
        !tabCheckedAll.includes(elt.id) ? tabCheckedAll.push(elt.id) : ""
      );
      response.data.map((elt) =>
        !tabChecked.includes(elt.id) ? tabChecked.push(elt.id) : ""
      );
      setIsAllChecked(tabCheckedAll);
      setCheckedCustomersIds(tabChecked);
      setUpdateCustomerData(response.data);
      setLoader(false);
      return response.data;
    } catch (error) {
      setLoader(false);
      console.log(error);
      if (error.response.data.message === "Unauthenticated.") {
        localStorage.clear();
        dispatch({ type: "SET_LOGOUT", payload: false });
      }
      throw error;
    }
  };

  /**
   * Cette fonction permet d'ajouter une nouvelle liste de clients en appelant une API.
   * Elle récupère le nom de la liste à ajouter et fait une requête POST à l'API.
   * Si la requête est réussie, la fonction appelle une autre fonction addStep2CustomerList pour ajouter les clients à la liste.
   * Si la requête échoue, elle affiche un message d'erreur et met à jour l'état de l'application.
   * @param { String } name - Le nom de la liste.
   */
  const addCustomerList = async () => {
    setLoaderAddUpdate(true);
    var idToast = toast.loading(
      `La liste ${nameCustomerList} est entrain de se créer.`
    );
    setErrorMessage("");
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        name: nameCustomerList,
        // <JC
        brand_id: valueBrands.value
        // JC>
      },
      "customer-lists",
      "post"
    )
      .then(function (response) {
        addStep2CustomerList(response.data.id, idToast);
      })
      .catch(function (error) {
        setLoaderAddUpdate(false);
        toast.update(idToast, {
          render: `Le nom ${nameCustomerList} de la liste est déjà utilisé.`,
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
        setErrorMessage("Ce nom est déjà utilisé.");
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction ajoute une nouvelle liste de clients avec les clients sélectionnés à partir des IDs dans l'application. Elle effectue deux étapes : elle crée d'abord une nouvelle liste de clients avec le nom spécifié, puis elle ajoute les clients sélectionnés à la liste créée.
   * @param { Number } id - L'ID de la liste de clients créée dans la première étape.
   * @param { String } idToast - L'ID du toast pour afficher les messages de succès ou d'erreur.
   * @param { String } checkedCustomersIds - Tableau de la liste de clients sélectionnés.
   */
  const addStep2CustomerList = async (id, idToast) => {
    setErrorMessage("");
    ApiService.request(
      {
        customer_ids: checkedCustomersIds.toString(),
        customer_list_id: id,
      },
      "customer-customer-lists",
      "post"
    )
      .then(function () {
        setLoaderAddUpdate(false);
        toast.update(idToast, {
          render: `La création de la liste ${nameCustomerList} est terminée.`,
          type: "success",
          isLoading: false,
          autoClose: 5000,
        });
        handleClose();
        getPlanCustomersList();
      })
      .catch(function (error) {
        setLoaderAddUpdate(false);
        if (error.response.data.message.includes("already exists")) {
          toast.update(idToast, {
            render: `Le nom ${nameCustomerList} de la liste est déjà utilisé.`,
            type: "error",
            isLoading: false,
            autoClose: 5000,
          });
          setErrorMessage("Ce nom est déjà utilisé.");
        } else {
          toast.update(idToast, {
            render: `Erreur lors de la création de la liste ${nameCustomerList}.`,
            type: "error",
            isLoading: false,
            autoClose: 5000,
          });
        }

        setErrorMessage("Erreur lors de la création de la liste.");
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction met à jour une liste de clients en modifiant son nom. Elle utilise l'API de l'application pour effectuer la modification.
   * @param { Number } customerListId - L'identifiant de la liste de clients à modifier.
   * @param { String } nameCustomerList - Le nouveau nom de la liste de clients.
   */
  const updateCustomerList = async () => {
    setLoaderAddUpdate(true);
    setErrorMessage("");
    var idToast = toast.loading(
      `La liste ${nameCustomerList} est entrain de se mettre à jour.`
    );
    ApiService.request(
      {
        name: nameCustomerList,
        // <JC
        brand_id: valueBrands.value
        // JC>
      },
      "customer-lists/" + customerListId,
      "put"
    )
      .then(function () {
        updateStep2CustomerList(idToast);
      })
      .catch(function (error) {
        setLoaderAddUpdate(false);
        if (error.response.data.message.includes("already exists")) {
          toast.update(idToast, {
            render: `Le nom ${nameCustomerList} de la liste est déjà utilisé.`,
            type: "error",
            isLoading: false,
            autoClose: 5000,
          });
          setErrorMessage("Ce nom est déjà utilisé.");
        } else {
          toast.update(idToast, {
            render: `Erreur lors de la modification de ${nameCustomerList}.`,
            type: "error",
            isLoading: false,
            autoClose: 5000,
          });
        }
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction met à jour la liste de clients sélectionnés pour une liste de clients donnée.
   * @param { Number } idToast - L'identifiant du toast pour afficher les messages de succès ou d'erreur.
   * @param { String } checkedCustomersIds - Tableau de la liste de clients sélectionnés.
   * @param { Number } customerListId - L'ID de la liste de clients.
   */
  const updateStep2CustomerList = async (idToast) => {
    setErrorMessage("");
    ApiService.request(
      {
        customer_ids: checkedCustomersIds.toString(),
        customer_list_id: customerListId,
      },
      "customer-customer-lists/" + 1,
      "put"
    )
      .then(function () {
        setLoaderAddUpdate(false);
        toast.update(idToast, {
          render: `La liste de clients ${nameCustomerList} s'est mis à jour.`,
          type: "success",
          isLoading: false,
          autoClose: 5000,
        });
        handleClose();
        dataPage.search && dataPage.search.length >= 3
          ? searchCustomersList(
              dataPage.search,
              dataPage.currentPage,
              dataPage.max
            )
          : getPlanCustomersList(dataPage.currentPage, dataPage.max);
      })
      .catch(function (error) {
        setLoaderAddUpdate(false);
        toast.update(idToast, {
          render: `Erreur lors de la mise à jour de la liste de clients ${nameCustomerList}.`,
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
        setErrorMessage("Erreur avec la sélection des clients.");
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction supprime une liste de clients à partir de son identifiant.
   * @param {Object} customerList - La liste de clients à supprimer.
   */
  const deleteCustomerList = async (customerList) => {
    
    if (
      window.confirm(
        "Voulez vous vraiment supprimer cette liste ? Cela est définitif."
      )
    ) {
      ApiService.request({}, "customer-lists/" + customerList.id, "delete")
        .then(function () {
          dataPage.search && dataPage.search.length >= 3
            ? searchCustomersList(
                dataPage.search,
                dataPage.currentPage,
                dataPage.max
              )
            : getPlanCustomersList(dataPage.currentPage, dataPage.max);
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };

  // <JC
  
  const deleteCustomerLists = (checkedIds) => {

    if (
      window.confirm(
        "Voulez vous vraiment supprimer ces listes de clients ? Cela est définitif."
      )
    ) {

      dispatch({ type: "SET_LOADER", payload: true });
      ApiService.request(
        {
          ids: checkedIds
        },
        `customer-lists-delete-bulk`,
        "post"
      )
        .then(function () {
          dataPage.search && dataPage.search.length >= 3
              ? searchCustomersList(
                  dataPage.search,
                  dataPage.currentPage,
                  dataPage.max
                )
              : getPlanCustomersList(dataPage.currentPage, dataPage.max);
          })
        .catch(function (error) {
          dispatch({ type: "SET_LOADER", payload: false });
          console.log(error.response.data.message);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };
  
  // JC>

  /**
   * Cette fonction permet de dupliquer une liste de clients en appelant l'API et en passant l'id de la liste à dupliquer dans le corps de la requête.
   * Elle met à jour la liste de clients après la duplication.
   * @param { Number } id - L'id de la liste de clients à dupliquer.
   */
  const duplicateCustomersList = async (id) => {
    setErrorMessage("");
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        id: id,
      },
      "customer-list-duplicate",
      "post"
    )
      .then(function () {
        dispatch({ type: "SET_LOADER", payload: false });
        getPlanCustomersList();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction effectue une requête pour récupérer les clients en fonction de différents critères : le statut, la recherche, le groupe et les tags. Les résultats de la requête sont stockés dans le state "customersListFilter".
   * Elle met également à jour les états "isAllChecked" et "checkedCustomersIds" en fonction des clients récupérés.
   */
  const getCustomersByGroupsStatusSearch = async () => {
    var valueTagsToSend = [];
    if (valueTags.length > 0) {
      valueTags.map((tag) => valueTagsToSend.push(tag.label));
    } else {
      valueTagsToSend = ["none"]; // "none" here means that we return all customers with tags or not
    }
    setLoader(true);
    setNoResultMessageInModal(false);
    ApiService.request(
      {
        status: valueStatus.label,
        search: searchValue,
        group_id: valueGroupement.value,
        tags: valueTagsToSend,
      },
      `customers-by-group-customer-status`,
      "post"
    )
      .then(function (response) {
        var tab = [];
        var tabCheckedAll = [...isAllChecked];
        var tabChecked = [...checkedCustomersIds];
        if (
          state.customersListFilter &&
          state.customersListFilter.length > 0 &&
          response.data.customers.length > 0
        ) {
          tab = state.customersListFilter;
          tab.unshift(response.data);
          dispatch({
            type: "SET_CUSTOMERSLISTFILTER",
            payload: tab,
          });
        } else if (response.data.customers.length > 0) {
          tab.push(response.data);
          dispatch({
            type: "SET_CUSTOMERSLISTFILTER",
            payload: tab,
          });
        }
        if (response.data.customers.length === 0) {
          setNoResultMessageInModal(true);
        } else {
          response.data.customers.map((elt) =>
            !tabCheckedAll.includes(elt.id) ? tabCheckedAll.push(elt.id) : ""
          );

          response.data.customers.map((elt) =>
            !tabChecked.includes(elt.id) ? tabChecked.push(elt.id) : ""
          );
          setIsAllChecked(tabCheckedAll);
          setCheckedCustomersIds(tabChecked);
        }
        setLoader(false);
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction récupère une liste de clients en fonction de leurs identifiants d'importation textuels, envoie une requête POST à l'API pour obtenir les données, puis met à jour les états des composants en conséquence.
   * @async
   * @function getCustomersByImportIds
   */
  const getCustomersByImportIds = async () => {
    setLoader(true);
    setNoResultMessageInModal(false);
    ApiService.request(
      {
        customer_ids: textImportId,
      },
      `customers-by-customer-ids`,
      "post"
    )
      .then(function (response) {
        setTextImportId("");
        var tab = [];
        var tabCheckedAll = [...isAllChecked];
        var tabChecked = [...checkedCustomersIds];
        if (
          state.customersListFilter &&
          state.customersListFilter.length > 0 &&
          response.data.customers.length > 0
        ) {
          tab = state.customersListFilter;
          tab.unshift(response.data);
          dispatch({
            type: "SET_CUSTOMERSLISTFILTER",
            payload: tab,
          });
        } else if (response.data.customers.length > 0) {
          tab.push(response.data);
          dispatch({
            type: "SET_CUSTOMERSLISTFILTER",
            payload: tab,
          });
        }
        if (response.data.customers.length === 0) {
          setNoResultMessageInModal(true);
        } else {
          response.data.customers.map((elt) =>
            !tabCheckedAll.includes(elt.id) ? tabCheckedAll.push(elt.id) : ""
          );

          response.data.customers.map((elt) =>
            !tabChecked.includes(elt.id) ? tabChecked.push(elt.id) : ""
          );
          setIsAllChecked(tabCheckedAll);
          setCheckedCustomersIds(tabChecked);
        }
        setLoader(false);
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction permet de supprimer une section de recherche dans l'accordéon des résultats de recherche.
   * @param { Number } index - L'index de la section de recherche à supprimer.
   * @param { Boolean } fromUpdate - Un indicateur facultatif pour indiquer si l'action de suppression provient d'une liste existante. La valeur par défaut est false.
   */
  const deleteAccordionSearch = async (index, fromUpdate = false) => {
    dispatch({ type: "SET_LOADER", payload: true });
    setLoader(true);
    var tabChecked = [...checkedCustomersIds];
    //console.log(tabChecked);
    if (fromUpdate) {
      updateCustomerData.forEach((elt) => {
        if (
          checkedCustomersIds.includes(elt.id) &&
          !state.customersListFilter.some((customers) =>
            customers.customers.some((e) => e.id === elt.id)
          )
        ) {
          var indexTab = tabChecked.indexOf(elt.id);
          tabChecked.splice(indexTab, 1);
        }
        setUpdateCustomerData([]);
      });
    } else {
      var dataCustomerDelete = state.customersListFilter[index].customers;
      //console.log(updateCustomerData);
      state.customersListFilter.splice(index, 1);

      dataCustomerDelete.forEach((elt) => {
        if (
          checkedCustomersIds.includes(elt.id) &&
          !state.customersListFilter.some((customers) =>
            customers.customers.some((e) => e.id === elt.id)
          ) &&
          !updateCustomerData.some((customerId) => customerId.id === elt.id)
        ) {
          var indexTab = tabChecked.indexOf(elt.id);
          tabChecked.splice(indexTab, 1);
        }
      });
    }

    //console.log(tabChecked);
    setCheckedCustomersIds(tabChecked);
    dispatch({ type: "SET_LOADER", payload: false });
    setLoader(false);
  };

  /**
   * Cette fonction récupère tous les groupements de clients depuis l'API et les ajoute dans un tableau d'options utilisé pour les filtres dans l'interface.
   */
  const getAllGroups = async () => {
    var options = [];
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request({}, `groups`, "get")
      .then(function (response) {
        dispatch({ type: "SET_LOADER", payload: false });
        response.data.map((brand) =>
          options.push({ value: brand.id.toString(), label: brand.name })
        );
        options.unshift({ value: "all", label: "Tous les groupements" });
        setGroupement(options[0]);
        dispatch({
          type: "SET_ALLGROUPS",
          payload: options,
        });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  React.useEffect(() => {
    getAllGroups();
    getPlanCustomersList();
  }, [refreshTab]);

  React.useEffect(() => {
    if (state.currentBrands && state.currentBrands.length === 1) {
      setTags(state.currentBrands[0]);
    } else if (state.currentBrands && state.currentBrands.length > 0) {
      setTags(state.currentBrands);
    } else {
      setTags([]);
    }
  }, [state.currentBrands]);

  const [formData] = React.useState({
    nameCustomerList: nameCustomerList || "",
    brands: valueTags || [],
  });
  const [newFormData, setNewFormData] = React.useState({
    ...formData,
  });

  // <JC
  React.useEffect(() => {
    if (state.currentBrands && state.currentBrands.length > 0) {
      getPlanCustomersList();
    } else {
      dispatch({ type: "SET_PLANSTRADECUSTOMERSLIST", payload: [] });
    }
  }, [state.currentBrands, state.currentYear, refreshTab]);
  // JC>

  /**
   * Cette fonction gère les changements de saisie utilisateur dans les champs de formulaire. Si le nom est "brands", la valeur sélectionnée est ajoutée au nouveau formulaire de données sous la clé "brands". Sinon, la valeur saisie dans le champ est ajoutée au nouveau formulaire de données sous la clé correspondante au nom du champ.
   * @param {Object} e - L'événement de changement de saisie utilisateur.
   * @param {String} name - Le nom du champ, optionnel. Par défaut, sa valeur est une chaîne vide.
   */
  const handleInputChange = (e, name = "") => {
    if (name === "brands") {
      setNewFormData({
        ...newFormData,
        brands: e,
      });
    } else {
      setNewFormData({
        ...newFormData,
        [e.target.name]: e.target.value,
      });
    }
  };

  /**
   * Cette fonction gère la fermeture d'une modal en vérifiant si des changements ont été effectués dans les données du formulaire. Si des changements ont été effectués, elle affiche une confirmation avant de fermer la modal.
   */
  const handleModalHide = () => {
    var windowConfirm = false;
    if (JSON.stringify(formData) !== JSON.stringify(newFormData)) {
      windowConfirm = true;
    }
    if (windowConfirm) {
      if (
        window.confirm(
          "Vous avez effectué des changements, êtes vous sûr de vouloir quitter sans valider ?"
        )
      ) {
        handleClose();
      }
    } else {
      handleClose();
    }
  };

  return (
    <>
      <ToastContainer />
      {showAdd && (
        <CustomersListModal
          handleClose={handleClose}
          show={showAdd}
          addOrUpdateCustomerList={addCustomerList}
          errorMessage={errorMessage}
          loader={loader}
          handleInputChange={handleInputChange}
          setNameCustomerList={setNameCustomerList}
          setSearchValue={setSearchValue}
          valueGroupement={valueGroupement}
          nameCustomerList={nameCustomerList}
          allGroups={state.allGroups}
          valueStatus={valueStatus}
          allStatus={allStatus}
          setStatus={setStatus}
          valueTags={valueTags}
          setTags={setTags}
          getCustomersByGroupsStatusSearch={getCustomersByGroupsStatusSearch}
          handleImportId={handleImportId}
          textImportId={textImportId}
          getCustomersByImportIds={getCustomersByImportIds}
          noResultMessageInModal={noResultMessageInModal}
          isAllChecked={isAllChecked}
          checkedCustomersIds={checkedCustomersIds}
          setCheckedCustomersIds={setCheckedCustomersIds}
          customersListFilter={state.customersListFilter}
          deleteAccordionSearch={deleteAccordionSearch}
          loaderAddUpdate={loaderAddUpdate}
          setGroupement={setGroupement}
          handleModalHide={handleModalHide}
          searchValue={searchValue}
          nameModal={"Ajouter"}

          // <JC
          valueBrands={valueBrands}
          setBrands={setBrands}
          allBrands={allBrands}
          // JC>

        />
      )}
      {showUpdate && (
        <CustomersListModal
          handleClose={handleClose}
          show={showUpdate}
          addOrUpdateCustomerList={updateCustomerList}
          errorMessage={errorMessage}
          loader={loader}
          handleInputChange={handleInputChange}
          setNameCustomerList={setNameCustomerList}
          setSearchValue={setSearchValue}
          valueGroupement={valueGroupement}
          nameCustomerList={nameCustomerList}
          allGroups={state.allGroups}
          valueStatus={valueStatus}
          allStatus={allStatus}
          setStatus={setStatus}
          valueTags={valueTags}
          setTags={setTags}
          getCustomersByGroupsStatusSearch={getCustomersByGroupsStatusSearch}
          handleImportId={handleImportId}
          textImportId={textImportId}
          getCustomersByImportIds={getCustomersByImportIds}
          noResultMessageInModal={noResultMessageInModal}
          isAllChecked={isAllChecked}
          checkedCustomersIds={checkedCustomersIds}
          setCheckedCustomersIds={setCheckedCustomersIds}
          customersListFilter={state.customersListFilter}
          deleteAccordionSearch={deleteAccordionSearch}
          loaderAddUpdate={loaderAddUpdate}
          setGroupement={setGroupement}
          handleModalHide={handleModalHide}
          searchValue={searchValue}
          updateCustomerData={updateCustomerData}
          nameModal={"Modifier"}

          // <JC 
          valueBrands={valueBrands}
          setBrands={setBrands}
          allBrands={allBrands}
          // JC> 

        />
      )}
      {state.plansTradeCustomersList ? (
        <TableDynamic
          controlTableId={"planslistCustomer"}
          columnsName={columnsName}
          columns={columns}
          data={state.plansTradeCustomersList.data}
          dataPagination={state.plansTradeCustomersList}
          showUpdate={handleShowUpdate}
          setShowDetailsPlan={setShowDetailsCustomerList}
          setDetailsPlan={setDetailsCustomerList}
          deleteD={deleteCustomerList}
          deleteDbulk={deleteCustomerLists}
          setNoResultMessage={setNoResultMessage}
          noResultMessage={noResultMessage}
          search={searchCustomersList}
          getDataPagination={getPlanCustomersList}
          duplicatePlanOrCustomersList={duplicateCustomersList}
        ></TableDynamic>
      ) : (
        <div className="text-center">
          <Spinner
            animation={state.loader ? "border" : false}
            role="status"
          ></Spinner>
        </div>
      )}
    </>
  );
};

export default CustomersList;
